import { usePageContext } from '../../../../providers/PageProvider';

export const FixtureSummary = () => {
  const {
    fixtureSource,
    chunkRanges,
    fixtureEventCount,
    loadedS3ChunkIndexes,
    loadedS3EventCount,
    emptyFixtureChunks,
  } = usePageContext();

  if (fixtureSource === 'none') {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-[8px] border border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-3 text-sm">
      <span className="text-[var(--color-text-muted)]">Artifacts</span>
      <span className="rounded-[6px] bg-[var(--color-info-bg)] px-2 py-1 text-[var(--color-info-text)]">
        {fixtureSource === 's3' ? 'S3' : fixtureSource === 'local-folder' ? 'Local Folder' : 'Pasted Events'}
      </span>
      <span className="rounded-[6px] bg-[var(--color-surface-muted)] px-2 py-1 text-[var(--color-text-muted)]">
        {chunkRanges.length} chunks
      </span>
      <span className="rounded-[6px] bg-[var(--color-surface-muted)] px-2 py-1 text-[var(--color-text-muted)]">
        {fixtureEventCount} events
      </span>
      {fixtureSource === 's3' ? (
        <span className="rounded-[6px] bg-[var(--color-surface-muted)] px-2 py-1 text-[var(--color-text-muted)]">
          {loadedS3ChunkIndexes.size} chunks loaded · {loadedS3EventCount} events loaded
        </span>
      ) : null}
      {emptyFixtureChunks.length ? (
        <span className="rounded-[6px] border border-[var(--color-error-border)] bg-[var(--color-error-surface)] px-2 py-1 text-[var(--color-error-heading)]">
          {emptyFixtureChunks.length} chunks without events
        </span>
      ) : null}
    </div>
  );
};
